import * as Updates from 'expo-updates'
import { useCallback, useEffect, useState } from 'react'
import { Alert } from 'react-native'
import { isWeb } from 'tamagui'

interface IUseAppUpdatesReturn {
  isCheckingForUpdate: boolean
  isDownloading: boolean
  updateAvailable: boolean
}

export function useAppUpdates(): IUseAppUpdatesReturn {
  const [isCheckingForUpdate, setIsCheckingForUpdate] = useState(false)
  const [isDownloading, setIsDownloading] = useState(false)
  const [updateAvailable, setUpdateAvailable] = useState(false)

  const downloadAndApplyUpdate = useCallback(async () => {
    try {
      setIsDownloading(true)

      await Updates.fetchUpdateAsync()

      await Updates.reloadAsync()
    } catch (error) {
      console.error('Erro ao baixar/aplicar update:', error)

      Alert.alert(
        'Atualização disponível',
        'Uma nova versão do app está disponível. Por favor, reinicie o aplicativo para atualizar.',
        [
          {
            text: 'Atualizar agora',
            onPress: async () => {
              try {
                await Updates.reloadAsync()
              } catch (reloadError) {
                console.error('Erro ao recarregar:', reloadError)
              }
            },
          },
          {
            text: 'Depois',
            style: 'cancel',
          },
        ],
      )
    } finally {
      setIsDownloading(false)
    }
  }, [])

  const checkForUpdates = useCallback(async () => {
    try {
      setIsCheckingForUpdate(true)

      const update = await Updates.checkForUpdateAsync()

      if (update.isAvailable) {
        setUpdateAvailable(true)
        await downloadAndApplyUpdate()
      }
    } catch (error) {
      console.error('Erro ao verificar updates:', error)
    } finally {
      setIsCheckingForUpdate(false)
    }
  }, [downloadAndApplyUpdate])

  useEffect(() => {
    if (isWeb || __DEV__) {
      return
    }

    checkForUpdates()
  }, [checkForUpdates])

  return {
    isCheckingForUpdate,
    isDownloading,
    updateAvailable,
  }
}
